import type { GroupRole } from "@/lib/consts";

type MembershipSettingsAccess = {
  isSuper: boolean;
  groupRole: GroupRole | null;
  organizationRole: "admin" | "member" | null;
  teamGroupAdmin: boolean;
  isPersonalGroup: boolean;
};

/**
 * Users Management. A personal workspace role is member or creator, so a
 * team-group admin reaches direct invite through that workspace only.
 */
export const canOpenMembershipSettings = ({
  isSuper,
  groupRole,
  organizationRole,
  teamGroupAdmin,
  isPersonalGroup,
}: MembershipSettingsAccess): boolean =>
  isSuper ||
  organizationRole === "admin" ||
  groupRole === "admin" ||
  (isPersonalGroup && teamGroupAdmin);
